<template>
    <div class="mainBox">
        <div class="main-header">
            <el-row :gutter="10">
                <el-col :span="24">
                    <el-button icon='el-icon-refresh' size="medium" @click='init'>刷新</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="main-content">
            <el-table
                :data="mainLists"
                row-key="id"
                border
                stripe
                default-expand-all
                class="common-tree-table"
                header-row-class-name='header_row_style'>
                <el-table-column
                    prop="name"
                    label="栏目名称"
                    min-width="120px">
                </el-table-column>
                <el-table-column
                    prop="id"
                    label="栏目ID"
                    min-width="120px">
                </el-table-column>
                <el-table-column
                    prop="type"
                    label="栏目类型"
                    min-width="120px">
                    <template slot-scope="scope">
                        {{scope.row.type=='news' ? '新闻' : '产品'}}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="sort"
                    label="栏目排序"
                    min-width="100px">
                </el-table-column>
                <el-table-column
                    prop="status"
                    label="状态"
                    align="center"
                    min-width="120px">
                    <template slot-scope="scope">
                        <el-switch
                            v-model="scope.row.status"
                            active-color="#409EFF"
                            active-value="active"
                            inactive-value="unactive"
                            disabled>
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="operation"
                    label="操作"
                    min-width="300px"
                    align="center">
                    <template slot-scope="scope">
                        <el-button
                            v-if="scope.row.pid == '0'"
                            type="success"
                            size="mini"
                            icon="el-icon-plus"
                            @click.stop="handleInsert(scope.row)">
                            添加子栏目
                        </el-button>
                        <el-button
                            type="primary"
                            size="mini"
                            icon="el-icon-edit-outline"
                            @click.stop="handleEdit(scope.row)">
                            编辑
                        </el-button>
                        <el-button
                            type="danger"
                            size="mini"
                            icon="el-icon-delete"
                            @click="handleDelete(scope.row)">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 添加栏目 -->
        <el-dialog title="栏目管理" :visible.sync="showColumnDialogVisible" @close='handleReset' width="600px" :close-on-click-modal='false'>
            <el-form ref="columnForm" :model="columnForm" :rules='formItemRules' label-width="100px" size="medium">
                <el-form-item prop="type" label="栏目类型" v-if='columnForm.pid != "0"'>
                    <el-select v-model="columnForm.type" placeholder="请选择栏目类型" clearable>
                        <el-option label="新闻" value="news"></el-option>
                        <el-option label="产品" value="products"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop='name' label='栏目名称'>
                    <el-input  v-model="columnForm.name" placeholder='请输入栏目名称' clearable></el-input>
                </el-form-item>
                <el-form-item prop='sort' label='栏目排序'>
                    <el-input  v-model="columnForm.sort" placeholder='数值越大越靠前' clearable></el-input>
                </el-form-item>
                <el-form-item prop='icon' label='栏目图标'>
                    <el-input  v-model="columnForm.icon" placeholder='请输入栏目图标' clearable></el-input>
                </el-form-item>
                <el-form-item prop='status' label='状态'>
                    <el-switch
                        v-model="columnForm.status"
                        active-color="#409EFF"
                        active-value="active"
                        inactive-value="unactive">
                    </el-switch>
                </el-form-item>
            </el-form>
            <template slot="footer">
                <el-button type="primary" size="medium" @click="handleSave">保存</el-button>
            </template>
        </el-dialog>
    </div>
</template>
<script>
    import {columnList,columnCreate,columnUpdate,columnDelete} from '@/utils/getData';

    export default{
        name:'column',
        data(){
            return{
                searchForm:{},
                mainLists:[],
                columnForm:{
                    name:'',//栏目名称
                    pid:'0',//父节点
                    sort:'0',//排序
                    status:"active"
                },
                formItemRules:{
                    type:[
                        {  required: true, message: '请选择栏目类型', trigger: 'change' }
                    ],
                    name: [
                        {  required: true, message: '请输入栏目名称', trigger: 'blur' }
                    ],
                    pid: [
                        {  required: true, message: '请选择父节点', trigger: 'change' }
                    ]
                },
                showColumnDialogVisible:false,
            }
        },
        mounted(){
            this.init();
        },
        methods:{
            async init(){
                try {
                    let res = await columnList();
                    if (res.code == 0) {
                        this.mainLists = res.data;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: 'error'
                        });
                    }
                } catch(e) {
                    this.$message({
                        showClose:true,
                        message: e.message,
                        type: 'error'
                    });
                }
            },
            handleInsert(currnetRow){//新增栏目
                try{
                    this.columnForm = Object.assign({},{status:'active',sort:'100'});
                    if(currnetRow.id){
                        this.columnForm.parent_title = currnetRow.name;
                        this.columnForm.pid = currnetRow.id;
                        this.columnForm.type = currnetRow.type;
                    }else{
                        this.columnForm.pid = '0';
                        this.columnForm.type = 'news';
                    }
                    this.showColumnDialogVisible = true;
                }catch (e) {
                    this.$message({
                        showClose:true,
                        message: e.message,
                        type: 'error'
                    });
                }
            },
            handleEdit(currentRow){//编辑父栏目
                this.columnForm = JSON.parse(JSON.stringify(currentRow));
                this.columnForm.parent_title = currentRow.parent_title ? currentRow.parent_title : '';
                this.showColumnDialogVisible = true;
            },
            handleDelete(currentRow){//删除
                this.$confirm('确定要删除吗', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    const res = await columnDelete({id:currentRow.id});
                    if (res.code == 0) {
                        this.mainLists = res.data;
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: 'success'
                        });
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: 'error'
                        });
                    }
                }).catch((e) => {
                    if(e == 'cancel'){
                        return false;
                    }
                    this.$message({
                        showClose:true,
                        message: e.message,
                        type: 'error'
                    });
                });
            },
            handleReset(){//重置表单
                this.$refs['columnForm'].resetFields();//重置表单数据
            },
            handleSave(){//保存
                this.$refs['columnForm'].validate(async (valid) => {
                    if(valid){
                        let res = {},formData = this.columnForm;
                        if(formData.id){//编辑
                            res = await columnUpdate(formData);
                        }else{//新增
                            res = await columnCreate(formData);
                        }
                        if (res.code == 0) {
                            this.mainLists = res.data;
                            this.showColumnDialogVisible = false;
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.message,
                                type: 'error'
                            });
                        }
                    }
                });
            }
        }
    }
</script>
<style scoped>
    .parent-id-btn{width: 100%;text-align: left;background: #fff;}
    .parentIdTree >>> .el-tree-node.is-current>.el-tree-node__content{color: #1876ef;}
    .treePopoverClass{height: 300px;overflow: auto;}
</style>